import React from 'react';
import { Link } from 'react-router-dom';

const release1 = {
    idx: 1,
    date: '2023-09-01',
    title: 'LobbyIQ Announces Seed Funding',
    body: (
        <div className="flex flex-col gap-6">
            <p>
                Published on September 1, 2023
                <br />
                London, Ontario
            </p>

            <p>
                LobbyIQ, an Ontario-based government relations technology start-up, announced its
                new product launch and first round of seed funding from private investors.
            </p>
            <p>
                “LobbyIQ provides unique insights and intelligence on stakeholder engagement with
                government policymakers, helping organizations develop advocacy and lobbying
                strategies” noted Guy Holburn, President and Co-Founder. “This round of seed funding
                from private investors will help LobbyIQ expand its product suite and grow its
                target market over the next year”, stated Christian Dippel, CEO and Co-Founder.
            </p>
            <p>
                <b>About LobbyIQ</b>
                <br />
                <i>Critical Intelligence for Government Relations and Parliamentary Affairs</i>
            </p>
            <p>
                LobbyIQ helps organizations effortlessly navigate the complex landscape of
                government relations and parliamentary affairs through the power of AI-driven
                analytics. Track custom issues, monitor committees in real-time, and leverage
                dashboard insights.
            </p>
            <p>
                For more information, visit{' '}
                <Link
                    className="text-blue-400 font-medium hover:underline"
                    to="https://ca.lobbyiq.org/"
                >
                    www.ca.lobbyiq.org
                </Link>{' '}
                or email contact@lobbyiq.org
            </p>
        </div>
    ),
};

export default release1;
